import React, { useState } from 'react'
import SignupForm from '../../components/form/SignUp/SignupForm';
import OtpVerification from '../../components/form/SignUp/OtpVerification';
import CustomNavbar from './PublicNavbar';


export default function SignupPage() {
    // const [toggle, setToggle] = useState('signup');
    // const [email, setEmail] = useState('');
    return (
        <>
            <CustomNavbar />
            {/* {toggle == 'signup' ? */}
            <div className="signup-page mt-4">
                <div className="signup-form-container2">
                    <SignupForm />
                </div>

            </div>
            {/* :
                toggle == 'otp' ?
                <div className="signup-page mt-5">
                    <div className="signup-form-container">
                     <OtpVerification email={email} />
                </div>
                </div>
                : ''} */}

        </>
    )
}
